import Pagination from '../valueobjects/Pagination';
import ExploreArea, { ExploreAreaInitializer } from './ExploreArea';
import ExploreMerchant from './ExploreMerchant';

export default class ExploreCategoryArea {
  public readonly exploreArea: ExploreArea;
  public readonly exploerMerchants: ExploreMerchant[];
  public readonly pagination: Pagination;

  constructor(init: ExploreCategoryAreaInitializer) {
    this.exploreArea = new ExploreArea(init.exploreArea);
    this.exploerMerchants = init.exploerMerchants.map(
      exploerMerchant => new ExploreMerchant(exploerMerchant),
    );
    this.pagination = new Pagination(init.pagination);
  }
}

export interface ExploreCategoryAreaInitializer {
  exploreArea: ExploreAreaInitializer;
  exploerMerchants: ExploreMerchant[];
  pagination: Pagination;
}
